import db from "../_root/apiBridge";
import { timestamp } from "../_root/apiBridge";

export async function getAdminCoinValueEditInsert(query: any): Promise<any> {
  return new Promise((resolve, reject) => {

    delete query.id;

    try {
      db.collection("coins_value")
        .add(query)
        .then(function (refDoc) {
          resolve({
            id: refDoc.id,
          });
        }).catch((error) => {
          reject(error);
        });
    } catch (error) {
      reject(error);
    }
  });
}

export async function getAdminCoinValueEditUpdate(
  id: string,
  query: any
): Promise<any> {
  return new Promise((resolve, reject) => {
    db.collection("coins_value")
      .doc(id)
      .update(query)
      .then(() => {
        resolve({
          id,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}


export async function getAdminCoinValueEditElim(id: string): Promise<any> {
  return new Promise((resolve, reject) => {
    try {
      db.collection("coins_value")
        .doc(id)
        .delete()
        .then(() => {
          resolve({
            id,
          });
        }).catch((error) => {
          reject(error);
        });
    } catch (error) {
      reject(error);
    }
  });
}
